<div class="modal" id="riderPairing" tabindex="-1">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
      <div class="modal-body p-0">
        <div class="container-fluid p-0 bg-light-gray">
          <div class="row row-cols-1 gy-2 m-0">
            <div class="col mt-0 navbar-spacer">
              <app-navbar
                class="fixed-top"
                [isShowBackButton]="true"
                [preventDefaultGoBack]="true"
                (goBackCallback)="hide()"
                [inputTitle]="'app.navbar.riderPairing'"
              />
            </div>
            @for (pairForm of pairingForms(); track $index) {
              <div class="col bg-primary-white px-4 py-3">
                @let rider = pairForm.rider;
                @let riderName = rider?.name;
                <div class="fs-5 fw-bold">
                  {{ `${riderName?.enName} ${riderName?.cnName}` }}
                </div>
                <div class="d-flex text-secondary mt-2">
                  <div class="text-nowrap">
                    @if (rider?.gender) {
                      <span
                        class="fas fa-person"
                        [class.fa-person]="rider?.gender === 'male'"
                        [class.fa-person-dress]="rider?.gender === 'female'"
                      ></span>
                    }
                    <span class="me-2">
                      {{ rider?.weight }}kg · {{ rider?.height }}cm
                    </span>
                  </div>
                  <div
                    class="bg-secondary-purple text-light rounded-pill px-2 flex-grow-1"
                  >
                    <span>
                      @let diag = rider?.diagnosis?.diagnosisStr;
                      @if (diag) {
                        {{ diag }}
                      } @else {
                        {{ 'app.details.noDisability' | translate }}
                      }
                    </span>
                  </div>
                </div>
                <form [formGroup]="pairForm.formGroup" class="mt-3">
                  <div class="text-secondary">
                    {{ 'app.riderPairing.volunteer' | translate }}
                  </div>
                  <div class="row gy-2 align-items-center">
                    <div class="col-4">
                      {{ 'app.riderPairing.leader' | translate }}
                    </div>
                    <div class="col-8 ps-0">
                      <select
                        formControlName="leaderSelect"
                        class="form-select form-select-lg"
                      >
                        <option value="" selected>
                          {{ 'app.riderPairing.selectVolunteer' | translate }}
                        </option>
                        @let leaderCtrl =
                          pairForm.formGroup.get('leaderSelect');
                        @for (vol of volunteers; track $index) {
                          @if (
                            !isVolunteerSelected(vol.id!) ||
                            leaderCtrl?.value === vol.id + ''
                          ) {
                            <option value="{{ vol.id }}">
                              {{ vol.name?.enName }}
                            </option>
                          }
                        }
                      </select>
                    </div>
                    <div class="col-4">
                      {{ 'app.riderPairing.sideHelper' | translate }}
                    </div>
                    <div class="col-8 ps-0">
                      <select
                        formControlName="helperSelect"
                        class="form-select form-select-lg"
                      >
                        <option value="" selected>
                          {{ 'app.riderPairing.selectVolunteer' | translate }}
                        </option>
                        @let helperCtrl =
                          pairForm.formGroup.get('helperSelect');
                        @for (vol of volunteers; track $index) {
                          @if (
                            !isVolunteerSelected(vol.id!) ||
                            helperCtrl?.value === vol.id + ''
                          ) {
                            <option value="{{ vol.id }}">
                              {{ vol.name?.enName }}
                            </option>
                          }
                        }
                      </select>
                    </div>
                  </div>
                  <div class="text-secondary mt-3 mb-2">
                    {{ 'app.riderPairing.equipment' | translate }}
                  </div>
                  <select
                    formControlName="equipmentSelect"
                    class="form-select form-select-lg"
                  >
                    <option value="" selected>
                      {{ 'app.riderPairing.selectEquipment' | translate }}
                    </option>
                    @let equiCtrl = pairForm.formGroup.get('equipmentSelect');
                    @for (equi of equipments; track $index) {
                      @if (
                        !isEquipmentSelected(equi.id!) ||
                        equiCtrl?.value === equi.id + ''
                      ) {
                        <option value="{{ equi.id }}">{{ equi.name }}</option>
                      }
                    }
                  </select>
                  <div class="text-secondary mt-3 mb-2">
                    {{ 'app.riderPairing.horse' | translate }}
                  </div>
                  <select
                    formControlName="horseSelect"
                    class="form-select form-select-lg"
                  >
                    <option value="" selected>
                      {{ 'app.riderPairing.selectHorse' | translate }}
                    </option>
                    @let horseCtrl = pairForm.formGroup.get('horseSelect');
                    @for (horse of horses; track $index) {
                      @if (
                        !isHorseSelected(horse.id!) ||
                        horseCtrl?.value === horse.id + ''
                      ) {
                        <option value="{{ horse.id }}">{{ horse.name }}</option>
                      }
                    }
                  </select>
                </form>
              </div>
            } @empty {
              @if (isPairingLoading) {
                <div class="col bg-primary-white ratio ratio-1x1">
                  <div class="d-flex justify-content-center align-items-center">
                    <div class="spinner-border text-secondary-purple"></div>
                  </div>
                </div>
              }
            }
            <div class="col mt-0 bg-primary-white py-5">
              <div class="container px-4 pb-4">
                <button
                  (click)="updatePairings()"
                  class="btn btn-primary w-100"
                  [disabled]="isPairingLoading || isUpdating"
                >
                  {{ 'app.riderPairing.submit' | translate }}
                  @if (isUpdating) {
                    <div
                      class="spinner-border text-light spinner-border-sm"
                    ></div>
                  }
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
